/* Look Pack — Ochi and Co — 2026-04-24
 * Lógica de seleccion de tallas, stock y agregar 2 productos al carrito.
 */
(function () {
  var section = document.querySelector('[data-look]');
  if (!section) return;

  var state = {
    top: { variantId: null, size: null, available: null },
    bottom: { variantId: null, size: null, available: null }
  };

  var cta = section.querySelector('[data-cta]');
  var feedback = section.querySelector('[data-feedback]');

  function setMsg(txt, isErr) {
    feedback.textContent = txt || '';
    feedback.classList.toggle('is-error', !!isErr);
  }

  function updateCta() {
    var t = state.top, b = state.bottom;
    if (t.variantId && b.variantId && t.available && b.available) {
      cta.disabled = false;
      cta.textContent = 'Llevar el pack';
      setMsg('');
    } else if ((t.size && !t.available) || (b.size && !b.available)) {
      cta.disabled = true;
      cta.textContent = 'Talla no disponible';
      setMsg('Una de las tallas no está disponible. Podés pedir aviso cuando vuelva.');
    } else {
      cta.disabled = true;
      cta.textContent = 'Elige las tallas';
      setMsg('');
    }
  }

  function pieceClick(piece, btn) {
    var sizes = section.querySelectorAll('[data-piece-sizes="' + piece + '"] .look-size-btn');
    sizes.forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var avail = btn.getAttribute('data-available') === 'true';
    state[piece] = {
      variantId: btn.getAttribute('data-variant-id'),
      size: btn.getAttribute('data-size'),
      available: avail
    };
    var bisBox = section.querySelector('[data-bis="' + piece + '"]');
    if (!avail) {
      var bisBtn = bisBox.querySelector('.klaviyo-bis-trigger');
      if (bisBtn) bisBtn.setAttribute('data-variant-id', state[piece].variantId);
      bisBox.hidden = false;
    } else {
      bisBox.hidden = true;
    }
    updateCta();
  }

  ['top', 'bottom'].forEach(function (piece) {
    var btns = section.querySelectorAll('[data-piece-sizes="' + piece + '"] .look-size-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () { pieceClick(piece, btn); });
    });
  });

  cta.addEventListener('click', function () {
    if (cta.disabled) return;
    var t = state.top, b = state.bottom;
    if (!t.variantId || !b.variantId) return;
    cta.disabled = true;
    cta.textContent = 'Agregando...';
    var packId = section.getAttribute('data-look-slug') ||
                 (window.location.pathname.split('/').pop() || 'look');
    var packTitle = (document.querySelector('.look-title') || {}).textContent || 'Look';
    var packImg = (section.querySelector('.look-media img') || {}).src || '';
    var body = {
      items: [
        { id: parseInt(t.variantId, 10), quantity: 1,
          properties: { _pack: packId, _pack_title: packTitle.trim(),
                        _pack_img: packImg, _pack_role: 'top' } },
        { id: parseInt(b.variantId, 10), quantity: 1,
          properties: { _pack: packId, _pack_title: packTitle.trim(),
                        _pack_img: packImg, _pack_role: 'bottom' } }
      ]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function (data) {
        setMsg('Pack agregado al carrito.');
        cta.textContent = 'Agregado ✓';
        // Usar la API del theme Symmetry: refrescar y abrir el cart-drawer.
        // Estos eventos están definidos en assets/cart-drawer.js del theme.
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }, 100);
        setTimeout(function () {
          cta.disabled = false; cta.textContent = 'Llevar el pack';
        }, 2200);
      })
      .catch(function (err) {
        console.error('Look pack add error', err);
        setMsg('No se pudo agregar al carrito. Intentá de nuevo.', true);
        cta.disabled = false;
        cta.textContent = 'Llevar el pack';
      });
  });
})();
